module.exports = __webpack_public_path__ + "static/media/Circle-on-disabled.d1dbb3af.svg";